export default "__VITE_ASSET__aa64186b__"